import { IGetAllItemFolhaPagamentoVerbaUseCase } from "../../../presentation/useCases/read/get_all_item_folha_pagamento_verba_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ItemFolhaPagamentoVerba } from "../../models/item_folha_pagamento_verba";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllItemFolhaPagamentoVerbaUseCase
 */

export class GetAllItemFolhaPagamentoVerbaUseCase
  extends BasePaginatedUseCase<ItemFolhaPagamentoVerba>
  implements IGetAllItemFolhaPagamentoVerbaUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllItemFolhaPagamentoVerba(
    idItemFolhaPagamento: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllItemFolhaPagamentoVerba(
      idItemFolhaPagamento,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
